var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/dropdown-menu.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/web.dom-collections.iterator.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'clsx';
import { supportsPassiveEvents } from 'detect-passive-events';
import React from 'react';
import { spring } from 'react-motion'; // @ts-ignore: TODO: upgrade react-overlays. v3.1 and above have TS definitions

import Overlay from 'react-overlays/lib/Overlay';
import { withRouter } from 'react-router-dom';
import { IconButton, Counter } from 'soapbox/components/ui';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
import Motion from 'soapbox/features/ui/util/optional-motion';
const listenerOptions = supportsPassiveEvents ? {
  passive: true
} : false;
let id = 0;

class DropdownMenu extends React.PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      mounted: false
    });

    _defineProperty(this, "node", null);

    _defineProperty(this, "focusedItem", null);

    _defineProperty(this, "handleDocumentClick", e => {
      if (this.node && !this.node.contains(e.target)) {
        this.props.onClose();
      }
    });

    _defineProperty(this, "setRef", c => {
      this.node = c;
    });

    _defineProperty(this, "setFocusRef", c => {
      this.focusedItem = c;
    });

    _defineProperty(this, "handleKeyDown", e => {
      if (!this.node) return;
      const items = Array.from(this.node.getElementsByTagName('a'));
      const index = items.indexOf(document.activeElement);
      let element = null;

      switch (e.key) {
        case 'ArrowDown':
          element = items[index + 1] || items[0];
          break;

        case 'ArrowUp':
          element = items[index - 1] || items[items.length - 1];
          break;

        case 'Tab':
          if (e.shiftKey) {
            element = items[index - 1] || items[items.length - 1];
          } else {
            element = items[index + 1] || items[0];
          }

          break;

        case 'Home':
          element = items[0];
          break;

        case 'End':
          element = items[items.length - 1];
          break;

        case 'Escape':
          this.props.onClose();
          break;
      }

      if (element) {
        element.focus();
        e.preventDefault();
        e.stopPropagation();
      }
    });

    _defineProperty(this, "handleItemKeyPress", e => {
      if (e.key === 'Enter' || e.key === ' ') {
        this.handleClick(e);
      }
    });

    _defineProperty(this, "handleClick", e => {
      const i = Number(e.currentTarget.getAttribute('data-index'));
      const item = this.props.items[i];
      if (!item) return;
      const {
        action,
        to
      } = item;
      this.props.onClose();
      e.stopPropagation();

      if (to) {
        e.preventDefault();
        this.props.history.push(to);
      } else if (typeof action === 'function') {
        e.preventDefault();
        action(e);
      }
    });

    _defineProperty(this, "handleMiddleClick", e => {
      const i = Number(e.currentTarget.getAttribute('data-index'));
      const item = this.props.items[i];
      if (!item) return;
      const {
        middleClick
      } = item;
      this.props.onClose();

      if (e.button === 1 && typeof middleClick === 'function') {
        e.preventDefault();
        middleClick(e);
      }
    });

    _defineProperty(this, "handleAuxClick", e => {
      if (e.button === 1) {
        this.handleMiddleClick(e);
      }
    });
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, false);
    document.addEventListener('keydown', this.handleKeyDown, false);
    document.addEventListener('touchend', this.handleDocumentClick, listenerOptions);

    if (this.focusedItem && this.props.openedViaKeyboard) {
      this.focusedItem.focus({
        preventScroll: true
      });
    }

    this.setState({
      mounted: true
    });
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('touchend', this.handleDocumentClick);
  }

  renderItem(option, i) {
    if (option === null) {
      return /*#__PURE__*/React.createElement("li", {
        key: "sep-".concat(i),
        className: "dropdown-menu__separator",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 179,
          columnNumber: 14
        }
      });
    }

    const {
      text,
      href,
      to,
      newTab,
      isLogout,
      icon,
      count,
      destructive
    } = option;
    return /*#__PURE__*/React.createElement("li", {
      className: classNames('dropdown-menu__item truncate', {
        destructive
      }),
      key: "".concat(text, "-").concat(i),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: href || to || '#',
      role: "button",
      tabIndex: 0,
      ref: i === 0 ? this.setFocusRef : null,
      onClick: this.handleClick,
      onAuxClick: this.handleAuxClick,
      onKeyPress: this.handleItemKeyPress,
      "data-index": i,
      target: newTab ? '_blank' : undefined,
      "data-method": isLogout ? 'delete' : undefined,
      title: text,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 9
      }
    }, icon && /*#__PURE__*/React.createElement(SvgIcon, {
      src: icon,
      className: "mr-3 h-5 w-5 flex-none",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 199,
        columnNumber: 20
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "truncate",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 11
      }
    }, text), count ? /*#__PURE__*/React.createElement("span", {
      className: "ml-auto h-5 w-5 flex-none",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Counter, {
      count: count,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 205,
        columnNumber: 15
      }
    })) : null));
  }

  render() {
    const {
      items,
      style,
      placement,
      arrowOffsetLeft,
      arrowOffsetTop
    } = this.props;
    const {
      mounted
    } = this.state;
    return /*#__PURE__*/React.createElement(Motion, {
      defaultStyle: {
        opacity: 0,
        scaleX: 1,
        scaleY: 1
      },
      style: {
        opacity: spring(1, {
          damping: 35,
          stiffness: 400
        }),
        scaleX: spring(1, {
          damping: 35,
          stiffness: 400
        }),
        scaleY: spring(1, {
          damping: 35,
          stiffness: 400
        })
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 217,
        columnNumber: 7
      }
    }, _ref => {
      let {
        opacity,
        scaleX,
        scaleY
      } = _ref;
      return (
        /*#__PURE__*/
        // It should not be transformed when mounting because the resulting
        // size will be used to determine the coordinate of the menu by
        // react-overlays
        React.createElement("div", {
          className: "dropdown-menu ".concat(placement),
          style: _objectSpread(_objectSpread({}, style), {}, {
            opacity: opacity,
            transform: mounted ? "scale(".concat(scaleX, ", ").concat(scaleY, ")") : undefined
          }),
          ref: this.setRef,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 222,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "dropdown-menu__arrow ".concat(placement),
          style: {
            left: arrowOffsetLeft,
            top: arrowOffsetTop
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 223,
            columnNumber: 13
          }
        }), /*#__PURE__*/React.createElement("ul", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 224,
            columnNumber: 13
          }
        }, items.map((option, i) => this.renderItem(option, i))))
      );
    });
  }

}

_defineProperty(DropdownMenu, "defaultProps", {
  style: {},
  placement: 'bottom'
});

const RouterDropdownMenu = withRouter(DropdownMenu);

class Dropdown extends React.PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      id: id++,
      open: false
    });

    _defineProperty(this, "target", null);

    _defineProperty(this, "activeElement", null);

    _defineProperty(this, "handleClick", e => {
      const {
        onOpen,
        onShiftClick,
        openDropdownId
      } = this.props;
      e.stopPropagation();

      if (onShiftClick && e.shiftKey) {
        e.preventDefault();
        onShiftClick(e);
      } else if (this.state.id === openDropdownId) {
        this.handleClose();
      } else if (onOpen) {
        const {
          top
        } = e.currentTarget.getBoundingClientRect();
        const placement = top * 2 < innerHeight ? 'bottom' : 'top';
        onOpen(this.state.id, this.handleItemClick, placement, e.type !== 'click');
      }
    });

    _defineProperty(this, "handleClose", () => {
      if (this.activeElement && this.activeElement === this.target) {
        this.activeElement.focus();
        this.activeElement = null;
      }

      if (this.props.onClose) {
        this.props.onClose(this.state.id);
      }
    });

    _defineProperty(this, "handleMouseDown", () => {
      if (!this.state.open) {
        this.activeElement = document.activeElement;
      }
    });

    _defineProperty(this, "handleButtonKeyDown", e => {
      switch (e.key) {
        case ' ':
        case 'Enter':
          this.handleMouseDown(e);
          break;
      }
    });

    _defineProperty(this, "handleKeyPress", e => {
      switch (e.key) {
        case ' ':
        case 'Enter':
          this.handleClick(e);
          e.stopPropagation();
          e.preventDefault();
          break;
      }
    });

    _defineProperty(this, "handleItemClick", e => {
      const i = Number(e.currentTarget.getAttribute('data-index'));
      const item = this.props.items[i];
      if (!item) return;
      const {
        action,
        to
      } = item;
      this.handleClose();
      e.preventDefault();
      e.stopPropagation();

      if (typeof action === 'function') {
        action(e);
      } else if (to) {
        var _this$props$history;

        (_this$props$history = this.props.history) === null || _this$props$history === void 0 ? void 0 : _this$props$history.push(to);
      }
    });

    _defineProperty(this, "setTargetRef", c => {
      this.target = c;
    });

    _defineProperty(this, "findTarget", () => {
      return this.target;
    });

    _defineProperty(this, "componentWillUnmount", () => {
      if (this.state.id === this.props.openDropdownId) {
        this.handleClose();
      }
    });
  }

  render() {
    const {
      src = require('@tabler/icons/dots.svg'),
      items,
      title,
      disabled,
      dropdownPlacement,
      openDropdownId,
      openedViaKeyboard = false,
      pressed,
      text,
      children,
      dropdownMenuStyle
    } = this.props;
    const open = this.state.id === openDropdownId;
    return /*#__PURE__*/React.createElement(React.Fragment, null, children ? /*#__PURE__*/React.cloneElement(children, {
      disabled,
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      onKeyDown: this.handleButtonKeyDown,
      onKeyPress: this.handleKeyPress,
      ref: this.setTargetRef
    }) : /*#__PURE__*/React.createElement(IconButton, {
      disabled: disabled,
      className: classNames({
        'text-gray-600 hover:text-gray-700 dark:hover:text-gray-500': true,
        'text-gray-700 dark:text-gray-500': open
      }),
      title: title,
      src: src,
      "aria-pressed": pressed,
      text: text,
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      onKeyDown: this.handleButtonKeyDown,
      onKeyPress: this.handleKeyPress,
      ref: this.setTargetRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 388,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement(Overlay, {
      show: open,
      placement: dropdownPlacement,
      target: this.findTarget,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 406,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(RouterDropdownMenu, {
      items: items,
      onClose: this.handleClose,
      openedViaKeyboard: openedViaKeyboard,
      style: dropdownMenuStyle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 407,
        columnNumber: 11
      }
    })));
  }

}

_defineProperty(Dropdown, "defaultProps", {
  title: 'Menu'
});

export default withRouter(Dropdown);